<template>
  <div class="page-wrap">
    <!-- 筛选栏 -->
    <el-card class="filter-card" shadow="never">
      <el-form :model="filterForm" inline>
        <el-form-item label="用户名/手机号">
          <el-input v-model="filterForm.keyword" placeholder="搜索用户名或手机号" clearable style="width:180px" @keyup.enter.native="loadList" />
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="filterForm.realName" placeholder="搜索真实姓名" clearable style="width:150px" @keyup.enter.native="loadList" />
        </el-form-item>
        <el-form-item label="学校">
          <el-input v-model="filterForm.school" placeholder="搜索学校" clearable style="width:150px" @keyup.enter.native="loadList" />
        </el-form-item>
        <el-form-item label="会员状态">
          <el-select v-model="filterForm.memberLevel" placeholder="全部" clearable style="width:120px">
            <el-option label="普通用户" :value="0" />
            <el-option label="会员" :value="1" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="loadList">搜索</el-button>
          <el-button @click="resetFilter">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card shadow="never">
      <el-table :data="tableData" border stripe v-loading="loading">
        <el-table-column type="index" width="60" label="#" />
        <el-table-column label="用户名" prop="nickname" min-width="120" />
        <el-table-column label="真实姓名" prop="realName" width="100" />
        <el-table-column label="学校" prop="school" min-width="140" show-overflow-tooltip />
        <el-table-column label="手机号" prop="mobile" width="140" />
        <el-table-column label="openId" prop="openId" show-overflow-tooltip />
        <el-table-column label="会员状态" width="110">
          <template #default="{ row }">
            <el-tag :type="row.isActiveMember ? 'warning' : 'info'" size="small">
              {{ row.isActiveMember ? '会员' : '普通' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="会员到期时间" prop="memberExpireTime" width="170" />
        <el-table-column label="注册时间" prop="createdAt" width="170" />
        <el-table-column label="操作" width="140" fixed="right">
          <template #default="{ row }">
            <el-button type="text" @click="openSchoolEdit(row)">编辑学校</el-button>
            <el-button type="text" class="danger-text" @click="deleteMember(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :current-page="page + 1"
        :page-sizes="[10, 20, 50]"
        :page-size="size"
        :total="total"
        layout="total, sizes, prev, pager, next"
      />
    </el-card>

    <el-dialog title="编辑学校" :visible.sync="schoolDialogVisible" width="420px">
      <el-form label-width="70px">
        <el-form-item label="用户">
          <span>{{ schoolForm.label }}</span>
        </el-form-item>
        <el-form-item label="学校">
          <el-input v-model="schoolForm.school" placeholder="请输入学校名称" clearable maxlength="100" show-word-limit />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="schoolDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="savingSchool" @click="saveSchool">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '../../utils/request'

export default {
  name: 'MemberList',
  data() {
    return {
      filterForm: { keyword: '', realName: '', school: '', memberLevel: null },
      tableData: [],
      page: 0,
      size: 10,
      total: 0,
      loading: false,
      schoolDialogVisible: false,
      savingSchool: false,
      schoolForm: { id: null, label: '', school: '' }
    }
  },
  created() {
    this.loadList()
  },
  methods: {
    loadList() {
      this.loading = true
      request.get('/member/list', {
        params: { page: this.page, size: this.size, ...this.filterForm }
      }).then(data => {
        this.tableData = data.content || []
        this.total = data.totalElements || 0
      }).finally(() => { this.loading = false })
    },
    resetFilter() {
      this.filterForm = { keyword: '', realName: '', school: '', memberLevel: null }
      this.page = 0
      this.loadList()
    },
    handlePageChange(val) { this.page = val - 1; this.loadList() },
    handleSizeChange(val) { this.size = val; this.page = 0; this.loadList() },
    openSchoolEdit(row) {
      this.schoolForm = {
        id: row.id,
        label: row.realName || row.nickname || row.mobile || row.id,
        school: row.school || ''
      }
      this.schoolDialogVisible = true
    },
    saveSchool() {
      if (!this.schoolForm.id) return
      this.savingSchool = true
      request.put(`/member/${this.schoolForm.id}/school`, { school: this.schoolForm.school })
        .then(() => {
          this.$message.success('学校已更新')
          this.schoolDialogVisible = false
          this.loadList()
        })
        .finally(() => { this.savingSchool = false })
    },
    deleteMember(row) {
      const label = row.realName || row.nickname || row.mobile || row.id
      this.$confirm(`确认删除用户「${label}」？删除后其刷题记录、错题、订单等数据将一并清除，且不可恢复。`, '删除用户', {
        type: 'warning',
        confirmButtonText: '删除',
        cancelButtonText: '取消'
      }).then(() => {
        request.delete(`/member/${row.id}`).then(() => {
          this.$message.success('已删除')
          this.loadList()
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.filter-card { margin-bottom: 16px; }
.pagination { margin-top: 16px; text-align: right; }
.danger-text { color: #ff4d4f; }
</style>
